import React from 'react';
import PageHeader from '@dashboard/components/PageHeader';

import GeneralSettingsForm from './components/GeneralSettingsForm';
import DeleteStoreSection from './components/DeleteStoreSection';
import SettingsContainer from '@/dashboard/components/SettingsContainer';

const SettingsGeneral = () => {
  return (
    <div className="p-4 space-y-4">
      <PageHeader
        title="General"
        description="Manage your store's branding and appearance, and set your default currency."
      />

      <div className="mb-32">
        <SettingsContainer size="lg">
          <GeneralSettingsForm />
          <DeleteStoreSection />
        </SettingsContainer>
      </div>
    </div>
  );
};

export default SettingsGeneral;
